<template>
  <section class="organizaciones">
    <p class="titleColorSystem text-center">organizaciones</p>
    <div class="sci-org-cont-buttons">
      <div class="sci-org-space"></div>
    </div>
    <div class="sci-org-content">
      <table class="sci-org-table">
        <v-card height="60px" flat>
          <v-bottom-nav
            :active.sync="bottomNav"
            :value="true"
            :color="configuracion.color_fuente"
            dark
          >
            <v-btn
              v-model="btn1"
              color="#ffc400"
              flat
              value="Empresa"
              @click="
                listarEmpresa();
                activeBtn = 'btn1';
              "
            >
              <span>Empresa</span>
              <v-icon :color="configuracion.color_sistema">card_travel</v-icon>
            </v-btn>

            <v-btn
              v-model="btn2"
              color="#ffc400"
              flat
              value="Asociación"
              @click="
                listarAsociacion();
                activeBtn = 'btn2';
              "
            >
              <span>Asociación</span>
              <v-icon :color="configuracion.color_sistema">people_alt</v-icon>
            </v-btn>
            <v-btn
              v-model="btn3"
              color="#ffc400"
              flat
              value="ONG"
              @click="
                listarONG();
                activeBtn = 'btn3';
              "
            >
              <span>ONG</span>
              <v-icon :color="configuracion.color_sistema">public</v-icon>
            </v-btn>
            <v-btn
              v-model="btn4"
              color="#ffc400"
              flat
              value="Clúster"
              @click="
                listarCluster();
                activeBtn = 'btn4';
              "
            >
              <span>Clúster</span>
              <v-icon :color="configuracion.color_sistema">account_tree</v-icon>
            </v-btn>
          </v-bottom-nav>
        </v-card>
        <v-divider></v-divider>
        <thead class="sci-org-thead">
          <div class="sci-org-busqueda" v-if="this.btn1 == true || this.btn2 == true || this.btn3 == true || this.btn4 == true">
            <input
              v-model="filtro"
              type="text"
              placeholder="Buscar Organización"
              @keyup.enter="listarOrg()"
              @click="limpiarCampos"
              autofocus
            /><button @click="listarOrg" class="sci-org-lupa"></button>
            <span class="sci-org-count">
            Hay {{ this.btn1 == true ? countEmpresa : this.btn2 == true ? countAsociacion : this.btn3 == true ? countONG : this.btn4 == true ? countCluster : '' }}
              {{
                this.btn1 == true
                  ? "Empresas"
                  : this.btn2 == true
                  ? "Asociaciones"
                  : this.btn3 == true
                  ? "ONG"
                  : this.btn4 == true
                  ? "Clusters"
                  : "resultados"
              }}
              que coinciden con la búsqueda</span
            >
            <vue-excel-xlsx
              v-if=" this.btn1 == true && organizaciones.length > 0"
              class="sci-org-excel"
              :data="organizaciones"
              :columns="columns"
              :filename="'Empresas'"
              :sheetname="'empresa'"
            >
              Descargar los datos de las Empresas
            </vue-excel-xlsx>
            <vue-excel-xlsx
              v-if=" this.btn2 == true && organizaciones.length > 0"
              class="sci-org-excel"
              :data="organizaciones"
              :columns="columns"
              :filename="'Asociaciones'"
              :sheetname="'asociaciones'"
            >
              Descargar los datos de las Asociaciones
            </vue-excel-xlsx>
            <vue-excel-xlsx
              v-if=" this.btn3 == true && organizaciones.length > 0"
              class="sci-org-excel"
              :data="organizaciones"
              :columns="columns"
              :filename="'ONG'"
              :sheetname="'ong'"
            >
              Descargar los datos de las ONG
            </vue-excel-xlsx>
            <vue-excel-xlsx
              v-if=" this.btn4 == true && organizaciones.length > 0"
              class="sci-org-excel"
              :data="organizaciones"
              :columns="columns"
              :filename="'Clusters'"
              :sheetname="'clusters'"
            >
              Descargar los datos de los Clusters
            </vue-excel-xlsx>
          </div>
          <tr class="sci-org-tr1">
            <td class="sci-org-tr1-nom">nombre</td>
            <td class="sci-org-tr1-nom">Domicilio</td>
            <td class="sci-org-tr1-nom">Municipio</td>
          </tr>
        </thead>
        <tbody class="sci-org-tbody">
          <tr
            class="sci-org-tr2"
            v-for="organizacion in filtrarOrg"
            :key="organizacion.id"
            @click="getCurrentElement(organizacion.id)"
          >
            <td class="sci-org-tbody-nom">{{ organizacion.nombre }}</td>
            <td class="sci-org-tbody-nom">{{ organizacion.domicilio }}</td>
            <td class="sci-org-tbody-nom">{{ organizacion.municipio }}</td>
          </tr>
        </tbody>
      </table>
      <v-card
        class="sci-org-show text-center"
        height="250px"
        width="650px"
        :elevation="selected"
        dark
      >
        <v-card-title>
          <span class="sci-org-title2">{{ CurrentElement.nombre }}</span>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <h4 class="sci-org-title3">Tipo de Organización:</h4>
          </v-flex>
          <v-flex xs12 md1>
            <p class="sci-org-title4">{{ CurrentElement.tipo_organizacion }}</p>
          </v-flex>

          <v-flex xs12 md8>
            <h4 class="sci-org-title3">Domicilio:</h4>
            <p class="sci-org-title4">{{ CurrentElement.domicilio }}</p>
          </v-flex>
          <v-flex xs12 md4>
            <h3 class="sci-org-title3">Municipio:</h3>
            <p class="sci-org-title4">{{ CurrentElement.municipio }}</p>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props: ["urlApi","configuracion"],
  data() {
    return {
      columns: [
        {
          label: "Nombre",
          field: "nombre",
        },
        {
          label: "Domicilio",
          field: "domicilio",
          dataFormat: this.priceFormat,
        },
        {
          label: "Municipio",
          field: "municipio",
        },
      ],
      selected: 4,
      btn1: false,
      btn2: false,
      btn3: false,
      btn4: false,
      tipo_org: null,
      organizaciones: [],
      allorganizaciones: [],
      empresa: [],
      asociacion: [],
      ong: [],
      cluster: [],
      filtro: "",
      activeBtn: "",
      CurrentElement: {},
    };
  },
   created() {
    this.listarEmpresa();
    this.listarAsociacion();
    this.listarONG();
    this.listarCluster();
    this.listarOrg();
  },
  methods: {
    //deben comentarse estas peticiones al API cuando se tengan datos en el API para que se empiece a usar vuex
    //ademas configurar los botones para que se haga la peticion desde ahi.
    listarOrg(tipo) {
      var url= process.env.VUE_APP_API_URL + "/api/organizaciones";
      axios
        .get(url)
        .then((todo) => {
          this.organizaciones = todo.data.Empresa;
        });
    },
    listarEmpresa() {
      this.CurrentElement.nombre = "";
      this.CurrentElement.tipo_organizacion = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.municipio = "";
      var url= process.env.VUE_APP_API_URL + "/api/organizaciones";
      axios
        .get(url)
        .then((empresa) => {
          if(empresa.data.Empresa != null){
            this.organizaciones = empresa.data.Empresa;
          }else{
            this.organizaciones = [];
          }
        });
    },
    listarAsociacion() {
      this.CurrentElement.nombre = "";
      this.CurrentElement.tipo_organizacion = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.municipio = "";
      var url= process.env.VUE_APP_API_URL + "/api/organizaciones";
      axios
        .get(url)
        .then((asoc) => {
          if(asoc.data.Asociación != null){
            this.organizaciones = asoc.data.Asociación;
          }else{
            this.organizaciones = [];
          }
        });
    },
    listarONG() {
      this.CurrentElement.nombre = "";
      this.CurrentElement.tipo_organizacion = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.municipio = "";
      var url= process.env.VUE_APP_API_URL + "/api/organizaciones";
      axios
        .get(url)
        .then((cluster) => {
          if(cluster.data.ONG != null){
            this.organizaciones = cluster.data.ONG;
          }else{
            this.organizaciones = [];
          }
        });
    },
    listarCluster() {
      this.CurrentElement.nombre = "";
      this.CurrentElement.tipo_organizacion = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.municipio = "";
      var url= process.env.VUE_APP_API_URL + "/api/organizaciones";
      axios
        .get(url)
        .then((asoc) => {
          if(asoc.data.Cluster != null){
            this.organizaciones = asoc.data.Cluster;
          }else{
            this.organizaciones = [];
          }
        });
    },
    getCurrentElement: function(ElementId) {
      this.CurrentElement = this.filtrarOrg.find((item) => {
        return item.id == ElementId;
      });
    },
    limpiarCampos() {
      this.filtro = "";
      this.CurrentElement.nombre = "";
      this.CurrentElement.tipo_organizacion = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.municipio = "";
    },
    ...mapMutations([""]),
    ...mapActions(["listarOrg"]),
  },
  computed: {
    countEmpresa() {return this.filtrarOrg.length;},
     countAsociacion() {return this.filtrarAsoc.length;},
    countONG() {return this.filtrarONG.length;},
    countCluster() {return this.filtrarCluster.length;},
   
    filtrarOrg() {
      return this.organizaciones.filter((organizacion) =>
        (
          organizacion.nombre.toLowerCase() +
          "" +
          organizacion.domicilio.toLowerCase() +
          "" +
          organizacion.municipio.toLowerCase() +
          "" +
          organizacion.id
        ).includes(this.filtro.toLowerCase())
      );
    },
    filtrarAsoc() {
      return this.asociacion.filter((organizacion) =>
        (organizacion.nombre.toLowerCase() +
        "" +
        organizacion.domicilio.toLowerCase() +
        "" +
        organizacion.municipio.toLowerCase() 
        +"" +organizacion.id
        ).includes(this.filtro.toLowerCase())
      );
    },
    filtrarONG() {
      return this.ong.filter((organizacion) =>
        (organizacion.nombre.toLowerCase() +
        "" +
        organizacion.domicilio.toLowerCase() +
        "" +
        organizacion.municipio.toLowerCase() 
        +"" +organizacion.id
        ).includes(this.filtro.toLowerCase())
      );
    },
    filtrarCluster() {
      return this.cluster.filter((organizacion) =>
        (organizacion.nombre.toLowerCase() +
        "" +
        organizacion.domicilio.toLowerCase() +
        "" +
        organizacion.municipio.toLowerCase() 
        +"" +organizacion.id
      ).includes(this.filtro.toLowerCase())
      );
    },
  },
};
</script>

<style scoped>
.active {
  background: #0084ff !important;
}
.sci-org-buttons button-active {
  background: red;
}
.sci-org-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-org-title2 {
  margin: 1% auto 0%;
  text-transform: uppercase;
  /* color:#000; */
  color: rgba(0, 132, 255, 1);
  font-weight: bold;
  font-size: 1.7em;
}
.sci-org-title3 {
  /* margin: 1% auto 0%; */
  text-transform: initial;
  color: #000;
  font-weight: bold;
  font-size: 1.1em;
}
.sci-org-title4 {
  color: #000;
}
.sci-org-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-org-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-org-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-org-cont-buttons {
  display: grid;
  grid-template-areas: "sci-org-buttons sci-org-space";
  margin: 2% 0 1% 0;
  grid-template-columns: 5fr 4fr;
}
.sci-org-buttons {
  display: grid;
  grid-area: sci-org-buttons;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  justify-content: space-around;
  align-content: space-between;
  width: 80%;
  margin: auto;
}
.sci-org-buttons button {
  background: rgba(0, 0, 36, 0.9);
  border: none;
  color: #fff;
  text-transform: uppercase;
  padding: 7px 0;
  /*font-weight: bold;*/
  font-size: 1em;
}
.active {
  background: rgba(150, 20, 210, 0.7);
  border: none;
}
.sci-org-space {
  display: grid;
  grid-area: sci-org-space;
}
.sci-org-content {
  display: grid;
  grid-template-areas: "sci-org-table sci-org-show";
  grid-template-columns: 5fr 4fr;
  text-transform: uppercase;
}
.sci-org-table {
  display: grid;
  grid-area: sci-org-table;
  border-spacing: 0;
  margin: auto;
  margin-bottom: 100px;
  width: 80%;
  align-content: start;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-org-thead {
  background: transparent;
  color: #fff;
  text-align: left;
}
.sci-org-busqueda {
  color: #000;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 0px;
}
.sci-org-busqueda input {
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-org-busqueda input:focus {
  outline: 0;
}
.sci-org-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-org-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 25px;
  position: relative;
  left: 34%;
  top: -44px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  /* border: 1px solid #aaa; */
}
.sci-org-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-org-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-org-count {
  color: #666666;
  font-size: 1.03rem;
  font-weight: bold;
  margin: 1rem 0;
}
.sci-org-excel{
  font-weight: bold;
  color: rgb(117, 180, 239);
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: .4rem;
  margin: 0rem 0 1rem 0;
  border-radius: 5px;
}
.sci-org-tr1 {
  display: grid;
  /* grid-template-columns: 1.5fr 2.5fr 2.5fr 2fr; */
  grid-template-columns: 2.5fr 2.5fr 2.5fr;
  text-transform: uppercase;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-org-tbody {
  /* border: 1px solid #000; */
  text-align: left;
}
.sci-org-tr2 {
  display: grid;
  grid-template-columns: 2.5fr 2.5fr 2.5fr;
  text-transform: uppercase;
}
.sci-org-tr2 td {
  padding: 10px;
  /* border-bottom: 1px solid #000; */
}
.sci-org-show {
  display: grid;
  /* width: 90%; */
  grid-area: sci-org-show;
  /* background: #aaa; */
  background: rgba(245, 245, 245, 1);
  margin-bottom: 100px;
  /* padding: 15px; */
  -webkit-border-radius: 0px 10px 0px 10px;
}
.sci-org-nameOrg {
  text-align: left;
  margin: 2% 4%;
  color: #000;
  font-size: 1.5em;
}
.sci-org-cont-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-org-info1 {
  display: grid;
  width: 80%;
  margin: 0 auto;
}
.sci-org-info1 div,
.sci-org-info2 div {
  padding: 15px 0;
}
.sci-org-info1-p1,
.sci-org-info1-p2,
.sci-org-info1-p3,
.sci-org-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
}
.sci-org-info2 {
  display: grid;
}
.sci-org-info2-p1,
.sci-org-info2-p2,
.sci-org-info2-p3,
.sci-org-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
}
.sci-org-buttons button.router-link-exact-active {
  background: red;
}
.sci-org-tr1-nom {
  min-width: 25%;
}
.sci-org-tbody-nom {
  min-width: 25%;
  cursor: pointer;
}
@media only screen and (max-width: 850px) and (min-width: 100px) {
  .sci-org-cont-buttons {
    grid-template-areas: "sci-org-buttons";
    grid-template-columns: 1fr;
  }
  .sci-org-buttons {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  .sci-org-content {
    grid-template-areas: "sci-org-table";
    grid-template-columns: 1fr;
  }
  .sci-org-table {
    width: 90%;
    margin: 2% auto;
  }
  .sci-org-show {
    width: 90%;
    grid-area: auto;
    margin: 0 auto;
  }
}
.text-center{
  text-align: center;
}
</style>